var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.items}}),_c('v-btn',{on:{"click":function($event){return _vm.csv()}}},[_vm._v("extract")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }